import FlightPriceGeneral from './flightPriceGeneral';
import FlightPeriod from './flightPeriods';
import Aircraft from './aircraft';
import AirlineCompany from './airlineCompany';
import Airport from './airport';
import Currency from '../currency';
import FlightProvider from './flightProvider';

export default class FlightRountTrip {
  flightNo: string;
  code: string;
  departureDate: string;
  arrivalDate: string;
  departureHour: string;
  arrivalHour: string;
  duration: string;
  totalQuota: string;
  isActive: boolean;
  baggageLimit: string;
  handBaggageLimit: string;
  currency: Currency;
  airlineCompany: AirlineCompany;
  airplane: Aircraft;
  fromAirport: Airport;
  toAirport: Airport;
  packageProvider: FlightProvider;
  flightEndDate: string;
  flightPriceGenerals: FlightPriceGeneral[];
  flightPeriods: FlightPeriod[];
  flightQuotas: any[];
}
